import { render, staticRenderFns } from "./formUser.vue?vue&type=template&id=2b338bee&lang=pug&"
import script from "./formUser.vue?vue&type=script&lang=ts&"
export * from "./formUser.vue?vue&type=script&lang=ts&"
import style0 from "./formUser.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports